var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1902_5370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5281 15.2319L20.4542 19.1571L19.1571 20.4542L15.2319 16.5281C13.7714 17.6989 11.9548 18.3357 10.083 18.333C5.52901 18.333 1.83301 14.637 1.83301 10.083C1.83301 5.52901 5.52901 1.83301 10.083 1.83301C14.637 1.83301 18.333 5.52901 18.333 10.083C18.3357 11.9548 17.6989 13.7714 16.5281 15.2319ZM14.6893 14.5518C15.8526 13.3554 16.5023 11.7517 16.4997 10.083C16.4997 6.53734 13.6278 3.66634 10.083 3.66634C6.53734 3.66634 3.66634 6.53734 3.66634 10.083C3.66634 13.6278 6.53734 16.4997 10.083 16.4997C11.7517 16.5023 13.3554 15.8526 14.5518 14.6893L14.6893 14.5518Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1902_5370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcn);
export default __webpack_public_path__ + "static/media/searchIcn.4ca8a0c1d6f10d5f33c1b13b72ed10bb.svg";
export { ForwardRef as ReactComponent };